import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth/authContext';
import { routePaths } from '@/app/router/routePaths';
import { LoadingScreen } from '@/shared/ui/LoadingScreen';

/**
 * Gate for everything a captain needs to be signed in for.
 *
 * This is convenience, not protection: the actual authorisation lives in the
 * Firestore security rules. Removing this guard would expose no data.
 */
export function RequireAuth() {
  const { session } = useAuth();
  const location = useLocation();

  if (session.status === 'loading') {
    return <LoadingScreen label="Anmeldung wird geprüft …" />;
  }

  if (session.status === 'anonymous') {
    // Remember where the user wanted to go, so sign-in returns them there.
    return <Navigate to={routePaths.login} state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
